export enum UserType {
  GUEST = 'guest',
  HOST = 'host',
}

export enum CertType {
  KMC = 'kmcert',
  IDCARD = 'idcard',
}

export enum VerificationStatus {
  NONE = 'NONE',
  HOLD = 'HOLD',
  CERTIFIED = 'CERTIFIED',
  PENDING = 'PENDING',
  EMAIL_SENT = 'EMAIL_SENT',
  ID_VERIFIED = 'ID_VERIFIED',
}
